module.exports = __webpack_public_path__ + "img/16.e336f82a.jpg";